<template lang="pug">
  div.bank-packets
    e-toolbar(
    :items="items"
    :hideRemoveButton="true"
    :showTotal="true"
    :showViewPanel="false"
    :hideImportBtn="true"
    @deleteItems="deleteItems"
    :hideSearch="true"
    :hideAddButton="true"
    )
    e-table(
    :items="items"
    :showCheckbox="false"
    :defaultColumnWidth="150"
    @deleteItem="deleteItem"
    @editItem="editItem"
    :showEditButton="false"
    :showDeleteButton="false"
    )
      div(slot="file" slot-scope="props")
        a(
        v-if="props.row.file"
        href="#"
        @click.stop.prevent="startDownloadFile(props.row)"
        ) Скачать
        span(v-else) -

    router-view
</template>

<script>
import { bankPackets } from '@/api/api-endpoints'
import tableMixin from '@/components/table/table-mixin'

export default {
  mixins: [tableMixin],
  methods: {
    getDownloadEndpoint(row) {
      return bankPackets.sourceDownloadFile(row.id)
    },
    getEndpoint(route) {
      return bankPackets.sources(route)
    },
    getDeleteUrl() {
      return null
    },
  },
  created() {
    if (this.items && !this.items._meta.fields.file) {
      this.$store.commit(
        'mutateError',
        new Error('В мете отсутствует file требуемое для отображения ссылки!')
      )
    }
  },
}
</script>
